import store from './../store/store'
import HttpUtil from './HttpUtil'
import axios from 'axios'
import Vue from 'vue'
import RouteUtil from './RouteUtil'

class UserUtil {
  static login (username, password, resolve = null, reject = null) {
    let axiosInstance = axios.create({
      headers: {
        Accept: 'application/json'
      }
    })

    let requestBody = store.state.appSettings.defaultLoginRequest
    requestBody.username = username
    requestBody.password = password

    axiosInstance.post(store.state.appSettings.authurl, requestBody).then(response => {
      Vue.ls.set('token', response.data.access_token, response.data.expires_in * 1000)
      HttpUtil.resetInstance()
      UserUtil.loadUserInfo(resolve, reject)
    }).catch(response => {
      reject && reject(response)
    })
  }

  static logout (resolve = null, reject = null) {
    let axiosInstance = axios.create({
      headers: HttpUtil.getHeaders()
    })
    // Sin importar el resultado se limpia el token.
    Vue.ls.remove('token')
    store.commit('setUserInfo', null)
    HttpUtil.resetInstance()
    axiosInstance.post(store.state.appSettings.logouturl).then(response => {
      resolve && resolve(response)
    }).catch(error => {
      reject && reject(error)
    })
  }

  static loadUserInfo (resolve = null, reject = null) {
    if (store.state.userInfo === null) {
      let http = new HttpUtil('user')

      let manejaError = (response) => {
        console.error('No fue posible cargar el menú del usuario. Causa: ')
        console.error(response)
        reject && reject(response)
      }

      http.get(null, (response) => {
        let userInfo = response.data
        RouteUtil.getMenu(userInfo, (menu) => {
          userInfo.menu = menu
          store.commit('setUserInfo', userInfo)
          resolve && resolve(userInfo)
        }, manejaError)
      }, manejaError)
    } else {
      resolve && resolve(store.state.userInfo)
    }
  }

  static isInRol (rolParam) {
    if (store.state.userInfo !== null) {
      for (let i = 0; i < store.state.userInfo.roles.length; i++) {
        let rol = store.state.userInfo.roles[i]
        if (rol.id === rolParam) {
          return true
        }
      }
    }
    return false
  }

  static isAdmin () {
    return UserUtil.isInRol(1)
  }

  static can (userinfo, permiso) {
    return userinfo.permisos && userinfo.permisos.includes(permiso)
  }
}

export default UserUtil



// WEBPACK FOOTER //
// ./src/util/UserUtil.js